export const ADD_LOADING = 'ADD_LOADING';
export const SUBSTRACT_LOADING = 'SUBSTRACT_LOADING';
export const RESET_LOADING = 'RESET_LOADING';
export const RECEIVED_ALL = 'RECEIVED_ALL';
export const INIT_RECEIVED_ALL = 'INIT_RECEIVED_ALL';
